import React from "react";
import styles from "./MovementTable.module.css";

const assetData = [
  {
    category: "Cost Details",
    rows: [
      {
        label: "Opening",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Purchases",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Disposals",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Closing",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
    ],
  },
  {
    category: "Accumulated Depreciation",
    rows: [
      {
        label: "Opening",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Depreciation",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Disposals",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Closing",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
    ],
  },
  {
    category: "Net Book Value",
    rows: [
      {
        label: "Opening",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
      {
        label: "Closing",
        values: [
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
          "20,00,000",
        ],
      },
    ],
  },
];

export default function FixedAssetsTable() {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        SUMMARY OF FIXED ASSETS FROM 01 APR 2025 TO 31 DEC 2025
      </h3>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              <th>CATEGORY OF ASSET</th>
              <th>PLANT AND MACHINES</th>
              <th>FURNITURE</th>
              <th>LAND</th>
              <th>BUILDING</th>
              <th>MOTOR VEHICLES</th>
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {assetData.map((section, idx) => (
              <React.Fragment key={idx}>
                <tr className={styles.sectionHeader}>
                  <td colSpan="7">{section.category}</td>
                </tr>
                {section.rows.map((row, i) => (
                  <tr key={i}>
                    <td>{row.label}</td>
                    {row.values.map((val, j) => (
                      <td key={j} className={styles.centerCell}>
                        {val}
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
